import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { debug } from 'util';

@Injectable({
  providedIn: 'root'
})

export class PopmtkgService {
  apiUrl: string;

  constructor(private _http: HttpClient) {
    this.apiUrl = 'https://mktgcost.iffco.coop/api/Popmktg/';
  }


  CostCentre(frmdt: string) {

    var params = new HttpParams().set('frmdt', frmdt);
    return this._http.get(this.apiUrl + 'CostCentre', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  postdata(frmdt: string, todt: string, orders: string) {
    debugger;
    var params = new HttpParams().set('frmdt', frmdt).set('todt', todt).set('orders', orders);
    return this._http.get(this.apiUrl + 'PostCentre', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

}
